import { CloseCircleOutlined, FilterOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';

import type { NSearchButtons } from '@app/components/SearchButtons/SeacrhButtons.types';

export const SearchButtons: NSearchButtons.Main = ({
  resetAll,
  showData,
  className,
}) => {
  return (
    <Space size="middle" className={className}>
      <Button
        icon={<CloseCircleOutlined />}
        onClick={resetAll}
        className="search-button"
        data-testid="reset-search"
      >
        Сбросить всё
      </Button>
      <Button
        id="test-users-list-search-button"
        icon={<FilterOutlined />}
        type="primary"
        onClick={showData}
        className="search-button"
        data-testid="show-search"
      >
        Показать
      </Button>
    </Space>
  );
};
